export default __webpack_public_path__ + "static/media/screenshot.5edb38ba.png";